import { render, staticRenderFns } from "./WebWidgets.vue?vue&type=template&id=0b866d17&scoped=true&"
import script from "./WebWidgets.vue?vue&type=script&lang=js&"
export * from "./WebWidgets.vue?vue&type=script&lang=js&"
import style0 from "./WebWidgets.vue?vue&type=style&index=0&id=0b866d17&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b866d17",
  null
  
)

export default component.exports